module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-reward-single"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.rewards_single.nav_space'),
      "backButton": "true"
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-reward-single__main"
  }, [_c('search-bar'), _vm._v(" "), _c('catalog-reward-detail')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be77d4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RewardsSingle.vue
// module id = 548
// module chunks = 1